<!-- 交易汇总表 -->
<template>
  <div>
    <title-info>
      <li>生成报表</li>
    </title-info>
    <el-form label-width="100px">
      <el-row>
        <el-col :span="16">
          <el-form-item label="机构 :">
            <el-input
              style="width: 100%;"
              v-model="orgnNameCreate"
              readonly
              :disabled="roleId=='1004'"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="isShowOrgnTreeCreate=true"
                :disabled="roleId=='1004'"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报表类型 :">
            <el-select
              style="width: 100%;"
              v-model="reportType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in reportTypeDict"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="产品类型 :">
            <el-select
              style="width: 100%;"
              v-model="reporttype"
              placeholder="请选择"
            >
              <el-option
                v-for="item in productType"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开始日期:">
            <el-date-picker
              style="width: 100%;"
              class="dates"
              v-model="issueDateStart"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="截止日期 :">
            <el-date-picker
              class="dates"
              v-model="issueDateEnd"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <button
        class="topBtn"
        @click="handleCreateClick()"
        v-if="functionList.indexOf('1093')!='-1'"
      >生成报表</button>
      <button
        class="topBtn"
        @click="reset()"
        v-if="functionList.indexOf('1094')!='-1'"
      >重置生成条件</button>
    </el-row>

    <title-info>查询报表</title-info>
    <el-form label-width="100px">
      <el-row>
        <el-col :span="16">
          <el-form-item label="机构 :">
            <el-input
              style="width: 100%;"
              v-model="originData.orgnName"
              readonly
              :disabled="roleId=='1004'"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="isShowOrgnTreeSelect=true"
                :disabled="roleId=='1004'"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="开始日期:">
            <el-date-picker
              class="dates"
              v-model="originData.issueDateStart"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="截止日期 :">
            <el-date-picker
              class="dates"
              v-model="originData.issueDateEnd"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <button
        style="margin-right: 30px;"
        class="btn btn--search"
        @click="query()"
      >查询</button>
      <button
        class="btn btn--reset"
        @click="resetSelect"
      >重置</button>
    </el-row>
    <li class="elementTable">
      <template>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
        >
          <el-table-column
            label="序号"
            width="50"
            prop="index"
            type="index"
          ></el-table-column>

          <el-table-column
            label="请求标识"
            :show-overflow-tooltip="true"
            :width="240"
            prop="reqContent"
          ></el-table-column>
          <el-table-column label="报表类型">
            <template
              slot-scope="scope"
              :show-overflow-tooltip="true"
            >
              <span
                v-for="(item,index) in reportRes(reportTypeDict,scope.row)"
                :key="index"
              >{{item.dictName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="产品类型"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                v-for="(item,index) in productRes(productType,scope.row)"
                :key="index"
              >{{item.dictName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="请求机构"
            :width="240"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{scope.row.reportOrgnName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="请求时间"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{scope.row.createTime | formatTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间"
            prop="ISSUE_DATE_START"
          >
            <template slot-scope="scope">
              <span>{{scope.row.issueDateStart | formatTime}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="截止时间"
            prop="ISSUE_DATE_END"
          >
            <template slot-scope="scope">
              <span>{{scope.row.issueDateEnd | formatTime}}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{statusMap[scope.row.status]}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <button
                v-if="scope.row.status=='1'"
                @click="download(scope.row.reqContent)"
                class="btn disable"
              >下载</button>
              <span v-else>——</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span>当前共{{sumCount}}条信息 ,{{currentPage}}/{{pageCount}}</span>
        </div>
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next,jumper"
          :total="sumCount"
        ></el-pagination>
      </template>
    </li>
    <yh-dialog
      title="机构名称"
      :visible.sync="isShowOrgnTreeCreate"
    >
      <el-tree
        style="width: 100%"
        :props="orgnPropsCreate"
        :load="loadChildOrgn"
        lazy
        highlight-current
        accordion
        @node-click="orgnChooseCreateM"
      ></el-tree>
      <span slot="footer">
        <el-button @click="isShowOrgnTreeCreate=false">取消</el-button>
        <el-button
          type="primary"
          @click="saveOrgnChooseCreate"
        >确定</el-button>
      </span>
    </yh-dialog>
    <yh-dialog
      title="机构名称"
      :visible.sync="isShowOrgnTreeSelect"
    >
      <el-tree
        style="widht: 100%"
        :props="orgnPropsSelect"
        :load="loadChildOrgn"
        lazy
        highlight-current
        accordion
        @node-click="orgnChooseSelectM"
      ></el-tree>
      <span slot="footer">
        <el-button @click="isShowOrgnTreeSelect=false">取消</el-button>
        <el-button
          type="primary"
          @click="saveOrgnChooseSelect"
        >确定</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import TitleInfo from '@/components/title.vue';
import { getFunctionList, getPagingData, pageCount } from '@/mixins';
import baseURL from '@/configs/base-url';

export default {
  name: 'ProductReport',
  components: {
    TitleInfo,
  },
  mixins: [getFunctionList, getPagingData, pageCount],
  data() {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      originData: {
        orgnName: sessionData.orgnName,
        reqUser: sessionData.userId,
        orgnCode: sessionData.orgnCode,
        issueDateStart: '',
        issueDateEnd: '',
      },
      // 报表生成状态
      statusMap: {
        0: '请求中',
        1: '已生成',
        2: '生成失败',
        3: '生成报表过大',
      },
      // 查询数据
      searchParam: {
        orgnName: '',
        reqUser: sessionData.userId,
        orgnCode: sessionData.orgnCode,
        issueDateStart: '',
        issueDateEnd: '',
      },
      functionList: [],
      roleId: sessionData.roleId,
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示记录数
      sumCount: 0, // 总记录数
      tableData: [], // 表格数据
      reporttype: '', // 产品类型
      issueDateStart: '', // 开始日期
      issueDateEnd: '', // 截止日期
      userId: JSON.parse(sessionStorage.getItem('sessionData')).userId, // 当前登录人ID
      productType: [],
      reportTypeDict: [],
      reportType: '',
      // 显示创建报表的机构树
      isShowOrgnTreeCreate: false,
      orgnCodeCreate: sessionData.orgnCode,
      orgnNameCreate: sessionData.orgnName,
      // 机构树选择的对象
      orgnChooseCreate: {},
      // 查询报表的机构树
      isShowOrgnTreeSelect: false,
      // 机构树选择的对象
      orgnChooseSelect: {},
      orgnPropsCreate: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      orgnPropsSelect: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
    };
  },
  mounted() {
    // 报表类型字典
    this.queryReportTypeDict().then(() => {
      // 产品类型字典
      this.queryProductTypeDict();
    });
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.refreshReport();
      },
    },
  },
  methods: {
    // 查询报表类型字典
    queryReportTypeDict() {
      const parames = {
        data: {
          dictTypeCode: 'report_type',
        },
      };
      return this.$_post(this.$API.selectDict, parames).then((res) => {
        this.reportTypeDict = res.data.list;
      });
    },
    // 查询产品类型字典
    queryProductTypeDict() {
      const parames = {
        data: {
          dictTypeCode: 'PRODUCT_TYPE',
        },
      };
      return this.$_post(this.$API.selectDict, parames).then((res) => {
        this.productType = res.data.list;
      });
    },
    // 生成报表
    handleCreateClick() {
      const checkParam = this.validate(
        [
          {
            prop: 'reportType',
            message: '请选择报表类型',
          },
          {
            prop: 'reporttype',
            message: '请选择产品类型',
          },
          {
            prop: 'issueDateStart',
            message: '请选择开始日期',
          },
          {
            prop: 'issueDateEnd',
            message: '请选择结束日期',
          },
        ],
        this,
      );
      if (!checkParam) {
        return;
      }
      if (this.issueDateStart > this.issueDateEnd) {
        this.$_yh_alert('结束日期不能小于开始日期');
      } else {
        this.$_yh_confirm('确定生成？').then(() => {
          const sessData = JSON.parse(sessionStorage.getItem('sessionData'));
          const params = {
            data: {
              reqUser: this.userId, // 工号
              roleId: sessData.roleId, // 人员ID
              orgnCode: this.orgnCodeCreate, // 机构
              orgnLevel: sessData.orgnLevel, // 机构等级
              workNo: sessData.workNo, // 工号
              dataAuth: sessData.dataAuth, // 权限
              productType: this.reporttype, // 产品类型
              issueDateStart: this.formatDate(this.issueDateStart), // 开始日期
              issueDateEnd: this.formatDate(this.issueDateEnd), // 结束日期
              reportType: this.reportType, // 报表类型
            },
          };
          this.createReport(params);
        });
      }
    },
    createReport(params) {
      return this.$_post(this.$API.reportPost, params).then(() => {
        this.refreshReport();
      });
    },
    // 重置生成条件
    reset() {
      const sessData = JSON.parse(sessionStorage.getItem('sessionData'));
      this.orgnCodeCreate = sessData.orgnCode;
      this.orgnNameCreate = sessData.orgnName;
      this.reportType = '';
      this.reporttype = '';
      this.issueDateStart = '';
      this.issueDateEnd = '';
    },
    // 查询按钮
    query() {
      this.searchParam = { ...this.originData };
      this.pageNo = 1;
      this.currentPage = 1;
      this.refreshReport();
    },
    // 重置按钮
    resetSelect() {
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
      // 重置后机构名称为默认当前登录机构
      this.originData.orgnName = sessionData.orgnName;
      this.originData.orgnCode = sessionData.orgnCode;
      this.originData.reqUser = sessionData.userId;
    },
    // 获取表格数据
    refreshReport() {
      if (this.originData.issueDateStart > this.originData.issueDateEnd) {
        this.$_yh_alert('结束日期不能小于开始日期');
        return;
      }
      this.getPagingData(this.$API.reportList);
    },
    // 报表类型处理
    reportRes(reportTypeDict, row) {
      return reportTypeDict.filter(
        report => report.dictValue === row.reportType,
      );
    },
    // 产品类型处理
    productRes(productType, row) {
      return productType.filter(report => report.dictValue === row.reportType);
    },
    // 下载
    download(FileName) {
      this.$_yh_confirm('是否下载此报表？').then(() => {
        const form = $('<form>'); // 定义一个form表单
        form.attr('style', 'display:none');
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr(
          'action',
          `${baseURL}${this.$API.reportDownload}?fileName=${FileName}`,
        );
        const fileInput = $('<input>');
        fileInput.attr('type', 'hidden');
        fileInput.attr('id', 'fileName'); // 设置属性的名字
        fileInput.attr('name', 'fileName'); // 设置属性的名字
        fileInput.attr('value', FileName); // 设置属性的值
        $('body').append(form); // 将表单放置在web中
        form.append(fileInput);
        form.submit(); // 表单提交
        form.remove();
      });
    },
    // 获取机构树节点数据
    loadChildOrgn(node, resolve) {
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      if (node.level === 0) {
        return resolve([
          {
            name: sessionData.orgnName,
            orgnCode: sessionData.orgnCode,
          },
        ]);
      }
      if (node.level > 0) {
        const temp = [];
        const parames = {
          data: {
            orgnCode: node.data.orgnCode,
          },
        };
        return this.$_post(this.$API.subOrganizationList, parames).then((res) => {
          // 将返回的子节点添加到
          for (let i = 0; i < res.data.info.children.length; i++) {
            const item = res.data.info.children[i];
            const item2 = {};
            item2.name = item.title;
            item2.orgnCode = item.id;
            temp[i] = item2;
          }
          resolve(temp);
        });
      }
      return '';
    },
    // 生成报表选择机构树子节点数据
    orgnChooseCreateM(data) {
      this.orgnChooseCreate = data;
    },
    // 查询报表选择机构树子节点数据
    orgnChooseSelectM(data) {
      this.orgnChooseSelect = data;
      this.originData.orgnName = this.orgnChooseSelect.name;
      this.originData.orgnCode = this.orgnChooseSelect.orgnCode;
    },
    // 生成报表弹框取消
    saveOrgnChooseCreate() {
      this.isShowOrgnTreeCreate = false;
      this.orgnCodeCreate = this.orgnChooseCreate.orgnCode;
      this.orgnNameCreate = this.orgnChooseCreate.name;
    },
    // 查询报表弹框取消
    saveOrgnChooseSelect() {
      this.isShowOrgnTreeSelect = false;
      this.orgnName = this.orgnChooseSelect.name;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/button.scss";
@import "../../../assets/css/ovflow.css";
a {
  color: beige;
}
.elementTable {
  margin-top: 5px;
}
.el-row {
  text-align: center;
}
.el-date-editor.el-input {
  width: 100% !important;
}
.topBtn {
  padding: 5px 16px;
  outline: none;
  border: 0;
  height: 30px;
  color: #fff;
  font-size: 13px;
  border-radius: 15px;
  background-color: #a2a7b3;
  margin-left: 10px;
}
</style>
